import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import Amount from "@/models/Shared/Amount";
import InstitutionWallet from "@/models/Accounts/InstitutionAccounts/InstitutionWallet";
import InstitutionAccountPaymentInterface from "@/models/Accounts/InstitutionAccounts/InstitutionAccountPaymentInterface";

export default class InstitutionAccount extends BaseInstitutionEntity {
    state: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    name: string;
    currency: string;
    oneApprovalThreshold: Amount;
    oneApprovalThresholdActive: boolean = false;
    twoApprovalThreshold: Amount;
    twoApprovalThresholdActive: boolean = false;
    threeApprovalThreshold: Amount;
    threeApprovalThresholdActive: boolean = false;
    wallets: InstitutionWallet[] = [];
    paymentInterfaces: InstitutionAccountPaymentInterface[] = [];
    transactionLimit: Amount = new Amount();
    dailyLimit: Amount = new Amount();
}